import React from "react"
import Button from "./Button"

interface ContinueButtonProps {
  className?: string;
  disabled?: boolean;
  i18nKey?: string;
  id?: string;
  onClick?: () => void;
  secondary?: boolean
}

const ContinueButton: React.FC<ContinueButtonProps> = (props: ContinueButtonProps) => {
  const { className = "Form-submit", disabled, i18nKey, id = "btn_continue", onClick, secondary } = props
  return (
    <Button
      className={className}
      disabled={disabled}
      i18key={i18nKey || "controls.buttons.continue"}
      id={id}
      large
      onClick={onClick}
      primary={!secondary}
      rightSymbolId="arrow-right"
      secondary={secondary}
      submit={!onClick}
    />
  )
}

export default ContinueButton
